module.exports = __webpack_public_path__ + "static/img/tab2.49895ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth/tab2.svg
// module id = zwgg
// module chunks = 0